module.exports = __webpack_public_path__ + "static/media/study 220404.420ee8c7.jpg";